// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import { 
    IsXsDownScreen
} from '../../../business-components/Service/GlobalService'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem1xs2,   
    GridItem2xs4,
    GridItem3,
    GridItem3xs4,
    GridItem4,
    GridItem6,
    GridItem8,
    GridItem10,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDadosHeaderBody,
} from '../../../business-components/Card/Card'

import {
    IconButtonClearEntradaDados,
    IconButtonMaisInformacoes,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaMensal,
} from './SimulacaoFinanceiraServiceAporteRetiradaMensal'

import {
    IdadeInicial,
    IdadeFinal,
    AporteMensal,
    RetiradaMensal,
    Observacao,
} from './SimulacaoFinanceiraCompAporteRetiradaMensal'

import SimulacaoFinanceiraFormAporteRetiradaMensalConfiguracao from './SimulacaoFinanceiraFormAporteRetiradaMensalConfiguracao'



const SimulacaoFinanceiraFormAporteRetiradaMensal = ({ values, handleChange }) => {

    processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaMensal(values)

    const isXsDownScreen = IsXsDownScreen()

    return (
        <FieldArray name="aporteRetiradaMensal">
            {(arrayHelpers) => (
                <CardGridEntradaDadosHeaderBody
                    title={LABEL.aportesRetiradasMensais}
                >
                    <DivForm>
                        {values.aporteRetiradaMensal?.map((item, ind) => {
                            return (
                                <div
                                    key={ind}
                                >
                                    <GridContainer>
                                        {!isXsDownScreen && (
                                            <GridItem1/>
                                        )}

                                        <GridItem2xs4>
                                            <IdadeInicial
                                                values={values}
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem2xs4>

                                        <GridItem2xs4>
                                            <IdadeFinal
                                                values={values}
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem2xs4>

                                        {isXsDownScreen && (
                                            <GridItem4/>
                                        )}
                            
                                        <GridItem3xs4>
                                            <AporteMensal
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem3xs4>
                                        
                                        <GridItem3xs4>
                                            <RetiradaMensal
                                                item={item}
                                                ind={ind}
                                                handleChange={handleChange}
                                            />
                                        </GridItem3xs4>

                                        <GridItem1xs2>
                                            <GridContainer>
                                                <GridItem6>
                                                    <CustomizedDialogsPopup
                                                        maxWidth="md"
                                                        popupTitle={LABEL.aporteMensal + ' / ' + LABEL.retiradaMensal}
                                                        tooltipTitle={LABEL.expandir}
                                                        PopupButton={IconButtonMaisInformacoes}
                                                        popupButtonDestaque={false}
                                                        popupComponent={
                                                            <SimulacaoFinanceiraFormAporteRetiradaMensalConfiguracao
                                                                values={values}
                                                                ind={ind}
                                                                item={item}
                                                                handleChange={handleChange}
                                                            />
                                                        }
                                                    />
                                                </GridItem6>

                                                <GridItem6>
                                                    <IconButtonClearEntradaDados
                                                        onClick={() =>
                                                            arrayHelpers.remove(ind)
                                                        }
                                                    />
                                                </GridItem6>
                                            </GridContainer>
                                        </GridItem1xs2>
                                    </GridContainer>

                                    {item.observacao && (
                                        <GridContainer>
                                            {!isXsDownScreen && (
                                                <GridItem3/>
                                            )}
                                            <GridItem8>
                                                <Observacao
                                                    item={item}
                                                    ind={ind}
                                                    handleChange={handleChange}
                                                />
                                            </GridItem8>
                                        </GridContainer>
                                    )}
                                </div>
                            )
                        })}
                        
                        <GridContainer>
                            {!isXsDownScreen && (
                                <GridItem1 />
                            )}
                            
                            <GridItem10
                                className={CLASSNAME().helpTextInLine}
                            >
                                {HELPTEXT.simulacaoFinanceiraFormAporteRetiradaMensal}
                            </GridItem10>
                        </GridContainer>
                    </DivForm>

                    <GridContainer>
                        {!isXsDownScreen && (
                            <GridItem1 />
                        )}

                        <GridItem10>
                            <ButtonIncluirLinha
                                align='right'
                                label={LABEL.buttonIncluirAporteRetiradaMensal} 
                                onClick={() => 
                                    arrayHelpers.push({})
                                }
                            />
                        </GridItem10>
                    </GridContainer>
                </CardGridEntradaDadosHeaderBody>
            )}
        </FieldArray>
    )
}

export default SimulacaoFinanceiraFormAporteRetiradaMensal